var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaveD(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1111,
    height: 409,
    viewBox: "0 0 1111 409",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M943.271 53.8335C957.314 59.685 970.576 66.7067 983.448 74.8988C1069.65 128.732 1124.26 233.669 1108.27 333.925C1091.89 435.74 984.228 580.467 877.74 601.532C843.024 608.554 807.528 598.802 773.593 588.269C716.643 570.715 663.204 542.237 607.034 525.853C585.191 519.612 561.397 518.051 540.333 526.633C503.667 541.457 494.695 573.445 479.093 605.824C461.54 642.493 431.895 673.311 396.008 692.426C322.286 731.435 227.11 713.101 158.848 670.97C57.431 608.554 21.1549 485.673 54.7006 374.105C63.2821 345.237 76.9344 316.76 99.5582 296.475C138.175 261.366 196.295 255.125 247.003 267.998C282.109 276.97 314.095 294.134 344.52 312.859C369.484 328.463 392.498 349.919 423.313 349.919C485.724 350.309 504.837 269.948 524.73 225.087C550.865 165.792 594.942 113.909 649.552 79.1899C737.707 22.6256 847.315 12.8731 943.271 53.8335Z",
    fill: "url(#paint0_linear_101_580)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.304 54.0706C957.34 59.9209 970.596 66.9412 983.462 75.1316C1069.63 128.954 1124.21 233.87 1108.22 334.105C1091.85 435.9 984.242 580.597 877.803 601.658C843.104 608.678 807.624 598.928 773.704 588.397C716.781 570.847 663.367 542.375 607.224 525.994C585.39 519.754 561.607 518.194 540.553 526.774C503.904 541.595 494.937 573.577 479.342 605.948C461.797 642.61 432.166 673.422 396.296 692.533C322.608 731.535 227.476 713.204 159.247 671.082C57.8768 608.678 21.6177 485.822 55.1477 374.277C63.7251 345.415 77.3711 316.944 99.9844 296.663C138.583 261.561 196.676 255.321 247.361 268.191C282.45 277.162 314.421 294.323 344.832 313.044C369.784 328.644 392.787 350.095 423.588 350.095C485.97 350.485 505.074 270.141 524.958 225.289C551.08 166.006 595.137 114.134 649.721 79.4218C737.835 22.869 847.392 13.1185 943.304 54.0706Z",
    fill: "url(#paint1_radial_101_580)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6655 855.097C-151.644 722.073 -48.667 429.109 121.012 339.386C184.593 305.837 258.705 292.964 330.087 302.326C394.448 310.909 474.802 332.754 540.723 307.788C590.652 288.673 613.666 241.471 639.8 198.56C712.352 79.1899 895.293 56.9542 986.179 170.083C1019.72 211.824 1033.38 269.948 1016.99 321.051C978.377 439.641 848.875 388.928 775.543 452.515C746.288 477.871 738.487 528.584 721.324 562.523C703.771 597.241 682.317 630.4 659.303 661.998C610.935 728.705 552.035 789.56 484.164 836.762C348.811 931.166 179.522 959.253 36.3675 863.679C32.4668 860.948 28.5661 858.218 24.6655 855.097Z",
    fill: "url(#paint2_linear_101_580)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6655 855.097C-151.644 722.073 -48.667 429.109 121.012 339.386C184.593 305.837 258.705 292.964 330.087 302.326C394.448 310.909 474.802 332.754 540.723 307.788C590.652 288.673 613.666 241.471 639.8 198.56C712.352 79.1899 895.293 56.9542 986.179 170.083C1019.72 211.824 1033.38 269.948 1016.99 321.051C978.377 439.641 848.875 388.928 775.543 452.515C746.288 477.871 738.487 528.584 721.324 562.523C703.771 597.241 682.317 630.4 659.303 661.998C610.935 728.705 552.035 789.56 484.164 836.762C348.811 931.166 179.522 959.253 36.3675 863.679C32.4668 860.948 28.5661 858.218 24.6655 855.097Z",
    fill: "url(#paint3_radial_101_580)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.5 209C438.103 209 424 194.897 424 177.5C424 160.103 438.103 146 455.5 146C472.897 146 487 160.103 487 177.5C487 194.897 472.897 209 455.5 209Z",
    fill: "url(#paint4_linear_101_580)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_580",
    x1: -17.1521,
    y1: 727.246,
    x2: 1460.73,
    y2: -79.8282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDF00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_101_580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(581.764 -77.0703) rotate(79.7207) scale(1206.28 1124.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5576,
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#D60B52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_101_580",
    x1: 1003.01,
    y1: -400.149,
    x2: 54.8375,
    y2: 1116.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9370"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_101_580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(726.435 162.015) rotate(-122.48) scale(1284.19 2158.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5576,
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#D60B52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_101_580",
    x1: 381.913,
    y1: 229.344,
    x2: 532.113,
    y2: 123.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5183,
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1178,
    height: 538,
    fill: "white",
    transform: "matrix(-1 0 0 1 1111 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveD);
export default __webpack_public_path__ + "static/media/wave_d.0c72730fbb2965f02b440545c9d32cbe.svg";
export { ForwardRef as ReactComponent };